import { render, staticRenderFns } from "./Consultantcertification.vue?vue&type=template&id=2dc21b88"
import script from "./Consultantcertification.vue?vue&type=script&lang=js"
export * from "./Consultantcertification.vue?vue&type=script&lang=js"
import style0 from "./Consultantcertification.vue?vue&type=style&index=0&id=2dc21b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports